/*
 * File: TaskTab.tsx
 * Project: a-a
 * File Created: Saturday, 9th November 2024 9:48:20 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 12th December 2025 12:32:51 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useCallback, useEffect, useState } from 'react';

import {
  Badge,
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Typography,
} from '@mui/material';
import zeplinColor from '../../../../theme/Color';

import { DashboardService } from '../../../../service/dashboard.service';

import CustomPopOver from '../../CustomPopOver/CustomPopOver';
// import ActivityCard from '../Activity/ActivityCard/ActivityCard';
// import TaskFilter from './TaskFilter/TaskFilter';
import CustomButton from '../../CustomButton/CustomButton';

// import { AuthService } from '../../../../service/auth.service';
import { LightTooltip } from '../../CustomTooltip/CustomTooltip';

import TaskTabColumn from './TaskTabColumn';

import CustomAlert from '../../CustomAlert/CustomAlert';
import CustomAlertContain from '../../CustomAlert/CustomAlertContain';
import { ClientService } from '../../../../service/client.service';
import { Link, useLocation, useParams } from 'react-router-dom';
import { TeamService } from '../../../../service/team.service';

import CustomAddTask from '../../CustomAddTask/CustomAddTask';
import style from './TaskTab.module.css';
import { HuddleDashboardService } from '../../../../service/huddle-dashboard.service';
import { HuddleClientService } from '../../../../service/huddle-client.service';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};

type TaskType = 'TODO' | 'IN_PROGRESS' | 'DONE';

const TaskTab = () => {
  // console.log(ApiConstants.SF_API.S3_UPLOAD.URL());

  const sf_redirect = sessionStorage.getItem('sf_redirect') || '';
  const sf_token = sessionStorage.getItem('SFToken') || '';
  const sf_edit = sessionStorage.getItem('sf_edit') || '';
  const sf_notes_content = sessionStorage.getItem('notes_content') || '';
  const sf_notes_id = sessionStorage.getItem('notes_id') || '';
  const sf_marked = sessionStorage.getItem('sf_marked') || '';
  const sf_delete = sessionStorage.getItem('sf_delete') || '';
  let parse_sf = {
    access_token: '',
    id: '',
    instance_url: '',
    issued_at: '',
    refresh_token: '',
    scope: '',
    signature: '',
    token_type: '',
  };
  if (sf_token) {
    parse_sf = JSON.parse(sf_token);
  }
  const params = useParams() || '';
  const location = useLocation();
  const details = location.pathname?.split('/');
  const [loading, setLoading] = useState(true);
  const user = sessionStorage.getItem('current-user') || '';
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [taskAnchorEl, setTaskAnchorEl] = React.useState<HTMLDivElement | null>(null);

  const [selectedItems, setSelectedItems] = useState<{
    priority: string[];
    status: string[];
    time: string[];
    client: string[];
    recordTypes: string[];
  }>({
    priority: [],
    status: [],
    time: [],
    client: [],
    recordTypes: [],
  });

  const [clientList, setClientList] = useState([]);

  // const [time, setTime] = React.useState('');
  const [overdueFilter, setOverdueFilter] = useState(false);

  const [activeChip, setActiveChip] = useState<string[]>([]); // Track if the chip is active
  const [recordTypesOptions, setRecordTypesOptions] = useState(['']);
  const [alert, setAlert] = React.useState('');

  const handleClose = () => {
    setAlert('');
  };

  const applyFilter = () => {
    getInProgressTask();
    getToDoTask();
    getDoneTask();
    setAnchorEl(null);
  };

  const handleSelection = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    const {
      target: { value },
    } = item;

    setSelectedItems({
      ...selectedItems,
      [key]: typeof value === 'string' ? value.split(',') : value,
    });
  };

  const handleContinueAdd = () => {
    handleModalClose();
    setDrawerState(true);
    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('sf_edit');
    sessionStorage.removeItem('sf_delete');
  };
  const handleTaskFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOverdueFilter(e.target.checked);
  };

  const handleClearAll = () => {
    setOverdueFilter(false);
    setSelectedItems({
      priority: [],
      status: [],
      time: [],
      client: [],
      recordTypes: [],
    });
    getToDoTask(false, true);
    getInProgressTask(false, true);
    getDoneTask(false, true);
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleTaskCreateClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!location?.pathname?.includes('huddle') && !location?.pathname?.includes('dashboard')) {
      if (sf_token === 'true') {
        setModalOpen(true);
      } else {
        setTaskAnchorEl(event.currentTarget);
      }
    } else {
      setModalOpen(true);
    }
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const openTask = Boolean(taskAnchorEl);
  const idTask = openTask ? 'simple-popover' : undefined;

  const [toDoData, setToDoData] = useState({
    done: 0,
    totalRecords: 0,
    records: [],
    service: '',
    inProgress: 0,
    todo: 0,
    totalFilteredRecords: 0,
  });
  const [inProgressData, setInProgressData] = useState({
    done: 0,
    totalRecords: 0,
    records: [],
    service: '',
    inProgress: 0,
    todo: 0,
    totalFilteredRecords: 0,
  });
  const [doneData, setDoneData] = useState({
    done: 0,
    totalRecords: 0,
    records: [],
    service: '',
    inProgress: 0,
    todo: 0,
    totalFilteredRecords: 0,
  });

  const [toDoLoading, setToDoLoading] = useState(true);
  const [inProgressLoading, setInProgressLoading] = useState(true);
  const [doneLoading, setDoneLoading] = useState(true);

  const [toDooffset, setToDoOffset] = useState(0);
  const [inProgressoffset, setInProgressOffset] = useState(0);
  const [doneoffset, setDoneOffset] = useState(0);

  const taskConfig = {
    TODO: {
      apiStatus: 'To Do',
      loadingSetter: setToDoLoading,
      offsetSetter: setToDoOffset,
      dataSetter: setToDoData,
      currentOffset: toDooffset,
    },
    IN_PROGRESS: {
      apiStatus: 'in progress',
      loadingSetter: setInProgressLoading,
      offsetSetter: setInProgressOffset,
      dataSetter: setInProgressData,
      currentOffset: inProgressoffset,
    },
    DONE: {
      apiStatus: 'Done',
      loadingSetter: setDoneLoading,
      offsetSetter: setDoneOffset,
      dataSetter: setDoneData,
      currentOffset: doneoffset,
    },
  };

  const fetchTasks = async (type: TaskType, next: boolean = false, clear: boolean = false) => {
    const config = taskConfig[type];

    // 1. Set Loading State
    config.loadingSetter(true);

    try {
      // 2. Build Query Params (Extracted to keep code clean)
      const recordTypesQuery = selectedItems.recordTypes
        .map((val) => encodeURIComponent(val))
        .join(',');
      const priorityQuery = selectedItems.priority.map((val) => val.toLocaleLowerCase()).join(',');
      const clientQuery = selectedItems.client.join(',');
      const timeQuery = selectedItems.time
        .map((val: string) =>
          val.toLocaleLowerCase() === 'day' ? 'today' : 'this' + val.toLocaleLowerCase(),
        )
        .join(',');
      const overdueQuery = overdueFilter ? `${overdueFilter}` : '';

      // Common payload for all services
      const commonPayload = {
        recordTypes: clear ? '' : recordTypesQuery,
        priority: clear ? '' : priorityQuery,
        client: clear ? '' : clientQuery,
        timeRange: clear ? '' : timeQuery,
        isOverdue: clear ? '' : overdueQuery,
        status: config.apiStatus,
        limit: 10,
        offset: next ? config.currentOffset : 0,
      };

      let primaryRequestPromise;
      let huddleRequestPromise;

      // 3. Conditional Huddle Request
      // We only fetch Huddle tasks if the offset is 0 (Initial load)
      const validPath = location?.pathname?.includes('dashboard');
      if ((config.currentOffset <= 0 || !next) && validPath) {
        huddleRequestPromise = HuddleDashboardService.getHuddleTasks({
          ...commonPayload,
          mailId: user,
        });
      } else {
        // If we are paginating, resolve immediately with null so we don't call the API
        huddleRequestPromise = Promise.resolve(null);
      }
      // 3. Service Selection Logic (Added HuddleDashboardService here)
      if (details[1] === 'team') {
        primaryRequestPromise = TeamService.getMemberTasks(params?.id ?? '', commonPayload);
      } else if (details[1] === 'clients') {
        primaryRequestPromise = location?.pathname?.includes('huddle')
          ? await HuddleClientService.getTasks(params?.id ?? '', commonPayload)
          : ClientService.getTasks(params?.id ?? '', commonPayload);
      } else {
        primaryRequestPromise = DashboardService.getTasks({ ...commonPayload, mailId: user });
      }
      const [res, resHuddle] = await Promise.all([primaryRequestPromise, huddleRequestPromise]);
      const combinedRecords = [
        ...(res?.records?.map((val: any) => ({
          ...val,
          source:
            details[1] === 'clients' && location?.pathname?.includes('huddle')
              ? 'HUDDLE'
              : 'SALESFORCE',
        })) || []),
        ...(resHuddle?.records?.map((val: any) => ({ ...val, source: 'HUDDLE' })) || []),
      ];

      // Calculate a combined total count if your UI needs it
      const combinedTotal =
        (res?.totalFilteredRecords || 0) + (resHuddle?.totalFilteredRecords || 0);

      const mergedResponse = {
        ...res,

        records: combinedRecords,
        totalFilteredRecords: combinedTotal,
      };
      config.offsetSetter(config.currentOffset + 10);
      if (combinedRecords.length > 0 || !next) {
        if (!next) {
          // Initial load or refresh: Replace data
          config.dataSetter(mergedResponse);
        } else {
          // Pagination: Append new merged records to existing state
          config.dataSetter((prev) => ({
            ...prev, // Keep previous metadata
            ...mergedResponse, // Update new metadata (like total)
            records: [...prev.records, ...mergedResponse.records], // Append new lists
          }));
        }
      }
    } catch (err) {
      setAlert('Something went wrong');
    } finally {
      // 6. Cleanup
      config.loadingSetter(false);
      setLoading(false);
    }
  };

  const getToDoTask = (next?: boolean, clear?: boolean) => {
    return fetchTasks('TODO', next, clear);
  };

  const getInProgressTask = (next?: boolean, clear?: boolean) => {
    return fetchTasks('IN_PROGRESS', next, clear);
  };

  const getDoneTask = (next?: boolean, clear?: boolean) => {
    return fetchTasks('DONE', next, clear);
  };
  const getClient = async () => {
    try {
      const res = await DashboardService.getClient();
      console.log(res);
      setClientList(res?.task_filter_values?.client);
      setRecordTypesOptions(res?.task_filter_values?.recordTypes);
    } catch (err) {
      console.log(err);
    }
  };

  const Priority = ['High', 'Normal', 'Low'];
  const TimeRange = ['Day', 'Week', 'Month'];
  const taskType = ['A&A Management Task', 'Brick Media Task', 'Payment Task'];
  // console.log(toDoLoading, inProgressLoading, doneLoading, 'total');
  const [modalOpen, setModalOpen] = React.useState(false);
  const [drawerState, setDrawerState] = React.useState(false);
  const [added, setAdded] = useState(false);
  const [edit, setEdit] = useState(false);
  const [action, setAction] = React.useState('');
  const [viewDrawerStateToDo, setViewDrawerStateToDo] = React.useState(false);
  const [viewDrawerStateInProgress, setViewDrawerStateInProgress] = React.useState(false);
  const [viewDrawerStateDone, setViewDrawerStateDone] = React.useState(false);
  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => {
    setModalOpen(false);
    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('sf_edit');
    sessionStorage.removeItem('sf_delete');
    sessionStorage.removeItem('sf_path');
  };
  // console.log(viewDrawerState);
  const handleAlertClose = () => {
    setAction('');
  };
  useEffect(() => {
    getToDoTask(false, false);
    getInProgressTask(false, false);
    getDoneTask(false, false);
    getClient();
    sf_redirect === 'Task' &&
      !sf_edit &&
      !sf_delete &&
      !sf_marked &&
      !sf_notes_content &&
      !sf_notes_id &&
      // parse_sf?.access_token &&
      sf_token === 'true' &&
      handleModalOpen();
    if (added) {
      setAlert('Task added successfully');
      setAdded(false);
    }
    if (edit) {
      setAlert('Task edited successfully');
      setEdit(false);
    }
  }, [drawerState, edit, sf_token]);
  useEffect(() => {
    if (action) {
      getToDoTask(false, false);
      getInProgressTask(false, false);
      getDoneTask(false, false);
      getClient();
      // setTimeout(() => setAction(false), 3000);
      handleAlertClose();
      setAlert(`Task ${action}`);
    }
    sessionStorage.removeItem('dealSelectedFromOverview');
  }, [action]);

  return (
    <Box sx={{ display: 'flex', gap: '40px', width: '100%', flex: 1, height: '100vh' }}>
      <Box sx={{ position: 'absolute', top: 0, right: 0, display: 'flex', gap: '16px' }}>
        {/* <CustomSearch /> */}
        <Badge
          badgeContent={Object.values(selectedItems).reduce(
            (prev, val) => (val?.length ? prev + 1 : prev),
            overdueFilter ? 1 : 0,
          )}
          color='primary'
          sx={{ '.MuiBadge-badge': { top: '0.7rem', right: '0.2rem' } }}
        >
          <LightTooltip
            title={
              <Typography variant='body3' color={zeplinColor.Neutral1}>
                Filter
              </Typography>
            }
            placement='bottom-end'
            style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
            // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
          >
            <Box
              sx={{
                borderRadius: '50px',
                width: { xs: '30px', xl: '50px' },
                height: { xs: '30px', xl: '50px' },
                border: `1px solid ${zeplinColor.Neutral6}`,
                padding: '0px 10px',
                display: 'flex',
                gap: 8,
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                //   flex: 1,
              }}
              onClick={handleClick}
            >
              <img src={'/assets/filter.svg'} className={style.filterIcon} />
            </Box>
          </LightTooltip>
        </Badge>
        <LightTooltip
          title={
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
              New task
            </Typography>
          }
          placement='bottom-end'
          style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
          // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
        >
          <Box sx={{ width: '100%' }}>
            <CustomButton
              disabled={false}
              onClick={handleTaskCreateClick}
              variant='contained'
              color={'primary'}
              buttonVariant='responsiveButtonLarge'
              style={{
                width: '100%',
                borderRadius: { xs: '10px', xl: '14px' },
                height: { xs: 30, xl: 48 },
                padding: { xs: '10px 12px', xl: '14px 16px' },
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={'New Task'}
              icon={<img src={`/assets/add-white.svg`} className={style['add-icon']} />}
              // tabindex={4}
            />
          </Box>
        </LightTooltip>

        <CustomPopOver
          setAnchorEl={setTaskAnchorEl}
          anchorEl={taskAnchorEl}
          id={idTask}
          sx={{
            borderRadius: '14px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
            marginTop: '8px',
            // marginRight: '2rem',
            // marginLeft: '-4rem',
          }}
        >
          <Box
            sx={{
              // height: { xs: '170px', xl: '202px' },
              width: { xs: '300px', xl: '340px' },
              padding: { xs: '18px', xl: '24px' },
              display: 'flex',
              gap: { xs: '26px', xl: '32px' },
              flexDirection: 'column',
            }}
          >
            <Box sx={{ display: 'flex', gap: { xs: '10px', xl: '16px' }, flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', gap: '12px', justifyContent: 'space-between' }}>
                <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                  Authentication Required
                </Typography>
                <img
                  src={'/assets/close-icon.svg'}
                  className={style['icon-24']}
                  alt='close'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setTaskAnchorEl(null);
                  }}
                />
              </Box>

              <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                {/* To create/edit a task, please ensure you're logged in to your Salesforce account. */}
                You need to be logged into Salesforce to perform this action. Please log in to your
                Salesforce account.
              </Typography>
            </Box>
            <Link
              // target='_blank'
              // rel='noopener noreferrer'
              to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
            >
              <CustomButton
                disabled={false}
                onClick={() => {
                  sessionStorage.setItem('sf_redirect', 'Task');
                  sessionStorage.setItem('sf_path', location?.pathname);
                }}
                variant='contained'
                buttonVariant='responsiveButtonLarge'
                color={'primary'}
                style={{
                  width: { xs: '125px', xl: '155px' },
                  borderRadius: { xs: '12px', xl: '14px' },
                  height: { xs: '38px', xl: '48px' },
                  padding: '14px 16px',
                  '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={'Open Salesforce'}
                // tabindex={4}
              />
            </Link>
          </Box>
        </CustomPopOver>
      </Box>

      <CustomPopOver
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        id={id}
        sx={{
          borderRadius: '14px',
          boxShadow: 'rgba(0, 0, 0, 0.15)',
          marginTop: '8px',
          marginRight: '2rem',
          marginLeft: '-4rem',
        }}
      >
        <Box
          sx={{
            height: params?.id ? { xs: '20rem', xl: '25rem' } : { xs: '22rem', xl: '27rem' },
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              padding: '16px',
              width: { xs: '250px', xl: '283px' },
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              height: '100%',
              overflow: 'auto',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                Filter
              </Typography>
              <Typography
                variant='responsiveButtonSmall'
                color={
                  Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                    ? zeplinColor.Neutral8
                    : zeplinColor.Brand1
                }
                onClick={
                  Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                    ? () => {}
                    : handleClearAll
                }
                sx={{
                  cursor:
                    Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                      ? 'default'
                      : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Clear All
              </Typography>
            </Box>

            {/* <div> */}
            <FormGroup
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
              }}
            >
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    fontSize: { xs: '14px', xl: '16px' },
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Record Types
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  multiple
                  value={selectedItems.recordTypes}
                  onChange={(e) => handleSelection(e, 'recordTypes')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                        // paddingLeft: '16px',
                        padding: '0px 14px',
                      }}
                      label='Record Types'
                    />
                  }
                  renderValue={(selected) => (selected as string[]).join(', ')}
                  MenuProps={MenuProps}
                  IconComponent={() => (
                    <img src='/assets/down-arrow.svg' className={style['icon-24']} />
                  )}
                >
                  {recordTypesOptions.map((name) => (
                    <MenuItem
                      key={name}
                      value={name}
                      sx={{
                        fontSize: { xs: '12px', xl: '16px' }, // Match responsive font size
                        padding: { xs: '6px 16px', xl: '8px 16px' }, // Adjust padding for better appearance
                      }}
                    >
                      <Checkbox
                        checked={selectedItems.recordTypes.indexOf(name) > -1}
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                        }}
                      />
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    fontSize: { xs: '14px', xl: '16px' },
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Priority
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  multiple
                  value={selectedItems.priority}
                  onChange={(e) => handleSelection(e, 'priority')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                        // paddingLeft: '16px',
                        padding: '0px 14px',
                      }}
                      label='Priority'
                    />
                  }
                  renderValue={(selected) => (selected as string[]).join(', ')}
                  MenuProps={MenuProps}
                  IconComponent={() => (
                    <img src='/assets/down-arrow.svg' className={style['icon-24']} />
                  )}
                >
                  {Priority.map((name) => (
                    <MenuItem
                      key={name}
                      value={name}
                      sx={{
                        fontSize: { xs: '14px', xl: '16px' }, // Match responsive font size
                        padding: { xs: '6px 16px', xl: '8px 16px' }, // Adjust padding for better appearance
                      }}
                    >
                      <Checkbox
                        checked={selectedItems.priority.indexOf(name) > -1}
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                        }}
                      />
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {params?.id ? (
                ''
              ) : (
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel
                    id='demo-multiple-name-label'
                    sx={{
                      fontSize: { xs: '14px', xl: '16px' },
                      '&.Mui-focused': { color: zeplinColor.Neutral9 },
                    }}
                  >
                    Client
                  </InputLabel>
                  <Select
                    labelId='demo-multiple-name-label'
                    IconComponent={() => (
                      <img src='/assets/down-arrow.svg' className={style['icon-24']} />
                    )}
                    id='demo-multiple-name'
                    multiple
                    value={selectedItems.client}
                    onChange={(e) => handleSelection(e, 'client')}
                    input={
                      <OutlinedInput
                        sx={{
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '1px',
                            color: zeplinColor.Neutral9,
                            borderColor: zeplinColor.Neutral9,
                          },
                          padding: '0px 14px',
                        }}
                        label='Client'
                      />
                    }
                    // IconComponent={() => (
                    //   <img src='/assets/down-arrow.svg' width='24px' height='24px' />
                    // )}
                    renderValue={(selected) => (selected as string[]).join(', ')}
                    MenuProps={MenuProps}
                  >
                    {clientList?.map((name) => (
                      <MenuItem
                        key={name}
                        value={name}
                        sx={{
                          fontSize: { xs: '14px', xl: '16px' }, // Match responsive font size
                          padding: { xs: '6px 16px', xl: '8px 16px' }, // Adjust padding for better appearance
                        }}
                      >
                        <Checkbox
                          checked={selectedItems.client.indexOf(name) > -1}
                          // color={zeplinColor.BasicBlack}
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    fontSize: { xs: '14px', xl: '16px' },
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Time range
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  // multiple
                  value={selectedItems.time}
                  onChange={(e) => handleSelection(e, 'time')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                        padding: '0px 14px',
                      }}
                      label='Time range'
                    />
                  }
                  IconComponent={() => (
                    <img src='/assets/down-arrow.svg' className={style['icon-24']} />
                  )}
                  renderValue={(selected) => selected[0]}
                  MenuProps={MenuProps}
                >
                  {TimeRange.map((name) => (
                    <MenuItem key={name} value={name} sx={{ fontSize: { xs: '14px', xl: '16px' } }}>
                      <Radio
                        checked={selectedItems.time[0] === name} // Check if this radio should be selected
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                          '& .MuiSvgIcon-root': {
                            fontSize: { xs: '18px', xl: '20px' },
                          },
                        }}
                      />
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ width: '100%' }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={overdueFilter}
                      // defaultChecked
                      onChange={handleTaskFilter}
                      sx={{
                        width: '51px', // Track width
                        height: { xs: '28px', xl: '31px' }, // Track height
                        padding: 0, // Remove internal padding for correct thumb alignment
                        '& .MuiSwitch-switchBase': {
                          padding: { xs: '0.6px 0px', xl: '1px 0px ' },
                          // display: 'flex',
                          // justifyContent: 'center',
                          // alignItems: 'center',
                          margin: '2px',
                          transitionDuration: '300ms',
                          '&.Mui-checked': {
                            transform: 'translateX(20px)', // Thumb moves 20px to the right when checked
                            color: zeplinColor.Blue, // Thumb color
                            '& + .MuiSwitch-track': {
                              backgroundColor: zeplinColor.BasicBlack, // Track color when the switch is on
                              opacity: 1, // Full opacity when on
                              border: 0,
                            },
                          },
                          '&.Mui-focusVisible .MuiSwitch-thumb': {
                            color: zeplinColor.Neutral9, // Color for thumb when focused
                            border: '1px solid #fff', // Focus border
                          },
                          '&.Mui-disabled .MuiSwitch-thumb': {
                            color: '#D3D3D3', // Disabled thumb color (light gray)
                          },
                          '&.Mui-disabled + .MuiSwitch-track': {
                            opacity: 0.7, // Track opacity when disabled
                          },
                        },
                        '& .MuiSwitch-thumb': {
                          boxSizing: 'border-box',
                          width: { xs: '23px', xl: '25px' }, // Thumb width
                          height: { xs: '23px', xl: '25px' }, // Thumb height
                          backgroundColor: zeplinColor.Neutral1, // Thumb color
                        },
                        '& .MuiSwitch-track': {
                          borderRadius: '100px', // Border radius for the off state (left side rounded)
                          backgroundColor: zeplinColor.Neutral5, // Track color when off
                          opacity: 0.6, // Track opacity when off
                          transition: 'background-color 300ms ease', // Smooth transition when toggling
                        },
                      }}
                    />
                  }
                  label='Overdue task'
                  labelPlacement='start'
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontSize: { xs: '16px', xl: '16px' }, // Apply responsive font size to the label
                    },
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginLeft: 0,
                    width: '100%',
                  }}
                />
              </FormControl>
              <Box sx={{ display: 'flex', alignItems: 'flex-end', flex: 1 }}>
                <CustomButton
                  onClick={applyFilter}
                  variant='contained'
                  disabled={
                    Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                  }
                  color={'primary'}
                  style={{
                    width: '100%',
                    borderRadius: '14px',
                    height: { xs: '48px', md: '56px' },
                  }}
                  textStyle={{
                    color:
                      Object.values(selectedItems).every((val) => val.length <= 0) && !overdueFilter
                        ? zeplinColor.Neutral8
                        : zeplinColor.Neutral1,
                    fontSize: { xs: '14px', xl: '16px' },
                  }}
                  text={'Apply'}
                />
              </Box>
            </FormGroup>
          </Box>
        </Box>
      </CustomPopOver>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {' '}
        <TaskTabColumn
          data={toDoData}
          loading={toDoLoading}
          getTask={getToDoTask}
          tabTitle={'To Do'}
          ellipse={'to-do-ellipse.svg'}
          setAction={setAction}
          action={action}
          setEdit={setEdit}
          setViewDrawerState={setViewDrawerStateToDo}
          viewDrawerState={viewDrawerStateToDo}
          // handleClose={handleAlertClose}
        />
      </Box>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <TaskTabColumn
          data={inProgressData}
          loading={inProgressLoading}
          getTask={getInProgressTask}
          tabTitle={'In Progress'}
          ellipse={'in-progress-ellipse.svg'}
          setAction={setAction}
          action={action}
          setEdit={setEdit}
          setViewDrawerState={setViewDrawerStateInProgress}
          viewDrawerState={viewDrawerStateInProgress}
          // handleClose={handleAlertClose}
        />
      </Box>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <TaskTabColumn
          data={doneData}
          loading={doneLoading}
          getTask={getDoneTask}
          tabTitle={'Done'}
          ellipse={'done-ellipse.svg'}
          setAction={setAction}
          action={action}
          setEdit={setEdit}
          setViewDrawerState={setViewDrawerStateDone}
          viewDrawerState={viewDrawerStateDone}
          // handleClose={handleAlertClose}
        />
      </Box>

      <CustomAlert
        open={alert ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alertIcon={
              alert?.length &&
              !alert?.includes('successfully') &&
              !alert?.includes('removed') &&
              !alert?.includes('moved') ? (
                <img src='/assets/error.svg' width={24} height={24} />
              ) : (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              )
            }
            alert={alert}
          />
        }
        error={
          alert?.length &&
          !alert?.includes('successfully') &&
          !alert?.includes('removed') &&
          !alert?.includes('moved')
            ? true
            : false
        }
      />
      {(modalOpen || drawerState) && (
        <CustomAddTask
          handleContinueAdd={handleContinueAdd}
          handleModalClose={handleModalClose}
          modalOpen={modalOpen}
          setDrawerState={setDrawerState}
          drawerState={drawerState}
          setAdded={setAdded}
          setTaskAnchorEl={setTaskAnchorEl}
        />
      )}
    </Box>
  );
};

export default TaskTab;
